import { FETCH_ALL_USERS, UPDATE_PROFILE } from "@/store/action-types";
import { SET_USER, SET_ALL_USERS, SET_LOADING } from "@/store/mutation-types";
import ApiService from "@/plugins/ApiService";

const state = {
    users: [],
    user: {}
}


const mutations = {

    [SET_ALL_USERS](state, response) {

        state.users = response.data
    },
    [SET_USER](state, user) {

        state.user = user
    }
}


const actions = {

    [FETCH_ALL_USERS]: async({ commit }) => {
        const response = await axios.get('users')
        commit(SET_ALL_USERS, response.data)

    },

    [UPDATE_PROFILE]({ state, commit, rootState }, payload) {

        commit(SET_LOADING, true)

        return new Promise((resolve, reject) => {
            ApiService.put(`users/${rootState.auth.authUser.id}`, payload)
                .then(() => {
                    commit(SET_LOADING, false)
                    resolve()
                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })
        })
    }



}

export default {
    state,
    mutations,
    actions
}